import _ from "underscore";
import ResultsPanelView from "app/views/map/ResultsPanelView";
import ServicePanelView from "app/views/map/ServicePanelView";
import LayerPanelView from "app/views/map/LayerPanelView";
import ButtonView from "core/views/ButtonView";
import $ from "jquery";
import ErrorUtils from "app/utils/ErrorUtils";
import SymbolFactory from "app/models/map/SymbolFactory";
import session from "app/Session";
import messenger from "app/Messenger";
import mapContext from "app/views/map/MapContext";
import FeatureResults from "app/models/map/FeatureResults";

export default {
  /**
   * Returns the View for a model.
   * @param model An object to display. A different view is selected based on which model is passed.
   */
  getViewForModel: function (model) {
    var view;

    if (_.isArray(model)) {
      // model is a form of feature results
      model = new FeatureResults(model);
    }

    if (model instanceof FeatureResults) {
      //showing list of geometries
      view = new ResultsPanelView();

      view.render();
    } else if (model.service) {
      //showing service
      view = new ServicePanelView({
        service: model,
      });

      view.render();
    } else if (model) {
      //showing layer
      var oldOpacity;
      var oldFactory;

      view = new LayerPanelView({
        layer: model,
      });

      view.render();

      view.on(
        "model-select",
        function (model) {
          mapContext
            .getOperation("show-geometry-details")
            .action([model])
            .fail(
              ErrorUtils.errorHandler({
                activity: "selecting the geometry",
              })
            );
        },
        this
      );

      oldOpacity = _.clone(model.layer.opacity);

      if (model.hasSymbolFactory()) {
        var symbolFactory = model.getSymbolFactory();

        //Create a new symbol factory so our old factory isn't changed by reference;
        oldFactory = new SymbolFactory(_.clone(symbolFactory.attributes));
      }

      var footer = $("<div></div>");
      var cancelButton = new ButtonView({
        text: "Revert",
        click: function () {
          view.setOpacity(oldOpacity);

          if (model.hasSymbolFactory()) {
            //Set the symbol factory off a clone of the original. If set off the original, can only revert once.
            view.setSymbolFactory(
              new SymbolFactory(_.clone(oldFactory.attributes))
            );
          }
        },
      });

      cancelButton.render();
      cancelButton.$el.appendTo(footer);

      if (model.featureLayer && model.featureLayer.allows(session, "update")) {
        var saveButton = new ButtonView({
          type: "primary",
          text: "Save",
          click: function () {
            model.featureLayer.set("opacity", model.layer.opacity);

            model.featureLayer.set(
              "appearance",
              model.getSymbolFactory().toJSON()
            );

            mapContext
              .getOperation("save-layer")
              .action(model)
              .fail(
                ErrorUtils.errorHandler({
                  activity: "saving the layer",
                })
              )
              .done(function (model, message) {
                messenger.success(message);
              });
          },
        });

        saveButton.render();
        saveButton.$el.appendTo(footer);
      }

      view.setFooter(footer);
    } else {
      view = new ResultsPanelView();

      view.render();
    }
    return view;
  },

  /**
   * Creates a context menu action to check all items in a given tree.
   * @param tree A JSTree instance
   * @param targetNode A JSNode instance that the user is checking all underneath.
   */
  getCheckAllAction: function (tree, targetNode) {
    return {
      text: "Check All",
      action: function () {
        var node = tree.get_node(targetNode);

        if (node) {
          _.each(node.children, function (childKey) {
            var childNode = tree.get_node(childKey);

            if (!tree.is_checked(childNode)) {
              tree.check_node(childNode);
            }
          });
        }
      },
    };
  },

  /**
   * Creates a context menu action to uncheck all items in a given tree
   * @param tree A JSTree instance
   * @param targetNode A JSNode instance that the user is unchecking all underneath.
   */
  getUncheckAllAction: function (tree, targetNode) {
    return {
      text: "Uncheck All",
      action: function () {
        var node = tree.get_node(targetNode);

        if (node) {
          _.each(node.children, function (childKey) {
            var childNode = tree.get_node(childKey);

            if (tree.is_checked(childNode)) {
              tree.uncheck_node(childNode);
            }
          });
        }
      },
    };
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/map/helpers/ViewHelper.js
// module id = 173
// module chunks = 1